             <!-- {{pageElement.label}} {{pageElement.value}} -->

<div class="form-group row mt-0 mb-0">
     <label for="variableName" class="col-sm-6 col-form-label col-form-label-sm align-self-center">
          {{pageElement.label}}
     </label>
     <div class="col-sm-6">
          <input type="text" class="form-control form-control-sm input-sm" id="pageElement.key"
               value="{{pageElement.value}}">
     </div>
</div>
       
